import { isPrimaryAndDerivedFrom, TitleCommon } from '@warehouse/title/core';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TopBarLegacy } from '../../../src/views/title/TopBarLegacy';
import titleSearchDisplayNameBuilder from '../../../src/utils/titles/titleSearchDisplayNameBuilder';

type TitleOverviewTopBarProps = {
	titleCommon: TitleCommon;
	actions: React.ReactNode;
};

export function TitleOverviewTopBar({ titleCommon, actions }: TitleOverviewTopBarProps) {
	const { title, subTitle1, subTitle2 } = titleSearchDisplayNameBuilder({
		tokens: titleCommon.readonly.titleSearchDisplayNameFullHTML,
	});

	const navigate = useNavigate();

	return (
		<TopBarLegacy
			title={title}
			subTitle1={subTitle1}
			subTitle2={subTitle2}
			onClickBack={() => {
				navigate(-1);
			}}
			isPrimaryAndDerivedFrom={
				titleCommon.readonly.parents ? isPrimaryAndDerivedFrom(titleCommon.readonly.parents) : false
			}
			actions={actions}
		/>
	);
}
